var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qr-dialog',{staticClass:"patient-qr",attrs:{"errorMessage":_vm.qrErrorMessage},on:{"close":_vm.onClose,"success":function($event){return _vm.QRData($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }